import { render, staticRenderFns } from "./IconAnnotationSolid.vue?vue&type=template&id=9ec95d00"
import script from "./IconAnnotationSolid.vue?vue&type=script&lang=js"
export * from "./IconAnnotationSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports